import React from 'react';
export const ImageCacheContext = React.createContext<Map<string, string>>(new Map());
